import type { FilterData } from '@which/shared'

import type { NeedsBasedAnswerOptionExtended } from '../../../../shared/types'
import { get } from '../../../../shared/utils/get'
import { updateFilter } from '../components/Filters/utils'

export const getDropdownPathsAndUpdatedFilters = ({
  filterData,
  option,
  removeFilterValue,
  addFilterValue,
}: GetDropdownPathsAndUpdatedFiltersArgs) => {
  const toPath = `${option.externalId}.to`
  const fromPath = `${option.externalId}.from`
  const currentFilterTo = get(filterData, toPath, []) as string[]
  const currentFilterFrom = get(filterData, fromPath, []) as string[]
  const updatedFilterTo = updateFilter({
    filter: currentFilterTo,
    filterValue: String(option?.to),
    removeFilterValue,
    addFilterValue,
  })
  const updatedFilterFrom = updateFilter({
    filter: currentFilterFrom,
    filterValue: String(option?.from),
    removeFilterValue,
    addFilterValue,
  })

  return { toPath, fromPath, updatedFilterTo, updatedFilterFrom }
}

type GetDropdownPathsAndUpdatedFiltersArgs = {
  filterData: FilterData
  option: NeedsBasedAnswerOptionExtended
  removeFilterValue?: boolean
  addFilterValue?: boolean
}
